import { StudentCourseLessonDataT } from "@interfaces/internal-study/students";
import React from "react";
import clsx from "clsx";
import style from "@scss/pages/study-center.module.scss";
import { LessonItem } from "./lesson-item";

type LessonsItemsPropsT = {
  items: StudentCourseLessonDataT[];
  courseId: number;
  stage: number;
};

const Lessons: React.FC<LessonsItemsPropsT> = ({ items, courseId, stage }) => {
  return (
    <div className={clsx(style.student_courses)}>
      {items.map((item, i) => (
        <LessonItem
          key={item.id}
          lesson={item}
          courseId={courseId}
          finish={stage > i}
          disabled={stage < i}
          last={items.length - 1 === i}
        />
      ))}
    </div>
  );
};

export default Lessons;
